/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ContactInfo from './ContactInfo/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import TreatmentInfo from './TreatmentInfo/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronRight from 'DesignSystem/Svgs/Tysiav2ChevronRight/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Relation({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/Relations/Content/Relation"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let relationFromPersonRecordValueData = fromData.useDataValue({ viewPath,
context: 'relation',
path: 'from_person_record',
})
let relationTypeValueData = fromData.useDataValue({ viewPath,
context: 'relation',
path: 'type',
})
let aggregateData = fromHelpers.format(relationFromPersonRecordValueData, relationTypeValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="left-start"
 offsetMainAxis={-32}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="Relation.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-ZzmQ7A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-ZzmQ7A': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-3-ZzmQ7A': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Relation.Vertical"
  data-view-path={viewPath}
 style={{'--g-3-ZzmQ7A': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="small"
 color={dtColorsNeutral900}
 data="relation.from_person_record"
 data="relation.type"
 aggregate="helpers.js format"
 text={aggregateData}
/>
<TreatmentInfo
  viewPath={`${viewPath}/TreatmentInfo`}
/>
</div>
<div
  data-testid="Relation.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Tysiav2ChevronRight
  viewPath={`${viewPath}/Tysiav2ChevronRight`}
/>
</div>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<ContactInfo
{...childProps}
  viewPath={`${viewPath}/ContactInfo`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}